import { Reducer } from 'redux';
import { SET_MIC, SET_SHARE_SCREEN, SET_HELP_CLICKED, ControlTypes } from '../actions/controls';

export interface ControlsState {
    mic: boolean;
    localVideo: boolean;
    shareScreen: boolean;
    HelpClicked: boolean;
}

const initialState: ControlsState = {
    mic: false,
    localVideo: false,
    shareScreen: false,
    HelpClicked: false
};

export const controlsReducer: Reducer<ControlsState, ControlTypes> = (
    state = initialState,
    action: ControlTypes
): ControlsState => {
    switch (action.type) {
        case SET_MIC:
            return { ...state, mic: action.mic };
        case SET_SHARE_SCREEN:
            return { ...state, shareScreen: action.shareScreen };
        case SET_HELP_CLICKED:
            return { ...state, HelpClicked: action.HelpClicked }
        default:
            return state;
    }
};
